<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('listeCampagnes.title') }}</h1>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #action>
      <button class="button is-addOrEdit"
        @click="checkPermissions(permCampagne.maj) ?
        $router.push({ name: 'm.bodac.campagne-add' })
        : showPopUp()"
        :class="{ 'button-access-no-permission' :
        !checkPermissions(permCampagne.maj) }">
        {{ $t('listeCampagnes.actions.addCampagne')}}
      </button>
    </template>
    <template #bar-left>
      <div class="column is-narrow">
        <selecteur-action
          @handleAction="manageActions"
          :options='actions'
          :placeholder='$t("general.placeHolder.groupedAction")'
          :titleButton="'general.button.apply'"
          :elementsSelectionnes="getAllCampagnesSelected().length > 0">
        </selecteur-action>
      </div>
      <form @submit.prevent="recherche()"
        class="column is-narrow  pdr-0">
        <b-input :placeholder="$t('general.button.search')"
          type="search"
          icon="magnify"
          v-model="critereRecherche.auto">
        </b-input>
      </form>
      <div class='column is-narrow'>
        <button class="button" @click='setShowFiltre'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">
            {{$t('general.button.filtre')}}
            <label class="has-text-weight-bold"
                    :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </template>
    <template #bar-right>
      <b-field class="column mg-0">
        <b-checkbox-button v-model="withoutImage" type="is-primary" outlined @input="recherche">
          <b-icon :icon="withoutImage ? 'image-off-outline' : 'image-outline'" class="mg-0">
          </b-icon>
        </b-checkbox-button>
      </b-field>
      <parametrage-table
        :reference-table="constantes.REFERENCE_TABLE_LISTE_CAMPAGNE"
        @endLoadParamtre="startArrayRendering = true">
      </parametrage-table>
    </template>
    <template #content>
      <v-server-table
        url=""
        v-if="startArrayRendering"
        :columns="columns"
        :options="options"
        :ref="constantes.REFERENCE_TABLE_LISTE_CAMPAGNE"
        @loaded="finLoading" @loading="debutLoading">
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[constantes.REFERENCE_TABLE_LISTE_CAMPAGNE].setLimit($event)"/>
        </template>
        <template slot="selected" slot-scope="props">
          <div class="has-text-centered">
            <b-checkbox v-model="props.row.selected"></b-checkbox>
          </div>
        </template>
        <div slot="image" slot-scope="props" class="has-text-centered">
          <image-view
            :permission="permCampagne"
            :image="props.row.cheminMin"
            :id="props.row.id"
            :libelle="props.row.libelle || ' '"
            :maxSize="true"
          />
        </div>
        <template slot="libelle" slot-scope="props">
          <router-link
            :to="{ name: 'c.bodac.campagne', params: { id: props.row.id } }"
            class="lien"
            :class="{'text-access-no-permission': !checkPermissions(permCampagne.lecture)}">
            {{ props.row.libelle }}
          </router-link>
        </template>
        <template slot="dateDebut" slot-scope="props">
          {{ getDate(props.row.dateDebut) }}
        </template>
        <template slot="dateFin" slot-scope="props">
          {{ getDate(props.row.dateFin) }}
        </template>
        <template slot="libelleInterne" slot-scope="props">
          {{ props.row.libelleInterne }}
        </template>
        <template slot="marque" slot-scope="props">
          {{ props.row.marque.libelle }}
        </template>
        <template slot="tags" slot-scope="props">
          <tag-list v-if="getListeTags(props.row.tags).length > 0"
                    :listes="getListeTags(props.row.tags)"/>
        </template>
        <template slot="creatorUser" slot-scope="props">
          {{ getUser(props.row.creatorUserId) }}
        </template>
        <template slot="visibleParLaMarque" slot-scope="props">
          <div class="has-text-centered">
            <b-checkbox v-model="props.row.visibleParLaMarque" disabled></b-checkbox>
          </div>
        </template>
        <template slot="actif" slot-scope="props">
          <div>{{ props.row.actif ? $t('general.oui') : $t('general.non') }}</div>
        </template>
        <template slot="edit" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="permCampagne.maj"
              @is-click="$router.push({ name: 'm.bodac.campagne-edit',
                params: { id: props.row.id } })"
              icon-type="is-success"
              icon="pencil-box-outline">
            </btn-action-icon>
          </div>
        </template>
        <template slot="archiver" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="permCampagne.supprimer"
              @is-click="openPopUpArchivage(props.row)"
              icon-type="is-default"
              :icon="props.row.actif ? 'archive' : 'archive-arrow-up'">
            </btn-action-icon>
          </div>
        </template>
        <template slot="delete" slot-scope="props">
          <div class="has-text-centered">
            <btn-action-icon
              :permission="permCampagne.supprimer"
              @is-click="openPopUpDelete(props.row)"
              icon-type="is-danger"
              icon="delete-forever">
            </btn-action-icon>
          </div>
        </template>
      </v-server-table>
    </template>
    <template #after-content>
      <b-modal v-model="isPopUpArchiver"
        has-modal-card
        class="modal">
        <pop-up-prevention
          :messHeader="$t(campagneToArchive.libelle)"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="isPopUpArchiver = false"
          @yes="archiverCampagne"/>
      </b-modal>
      <b-modal v-model="isPopUpDelete"
        has-modal-card
        class="modal">
        <pop-up-prevention
          :messHeader="$t('listeCampagnes.delete.confirmation')"
          :messagesPopup="messagesErreurPopUp"
          :isErrorPopup.sync="errorPopUp"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="isPopUpDelete = false"
          @yes="deleteCampagne"/>
      </b-modal>
      <b-modal v-model="popupMassVisible"
        has-modal-card
        class="modal">
        <pop-up-prevention
          :messHeader="$t('listeCampagnes.popupPrevention.visible')"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="popupMassVisible = false"
          @yes="updateCampagneVisible(true)"/>
      </b-modal>
      <b-modal v-model="popupMassNonVisible"
        has-modal-card
        class="modal">
        <pop-up-prevention
          :messHeader="$t('listeCampagnes.popupPrevention.nonVisible')"
          :cancel="$t('general.non')"
          :validate="$t('general.oui')"
          @no="popupMassNonVisible = false"
          @yes="updateCampagneVisible(false)"/>
      </b-modal>
    </template>
    <template #filter>
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-campagne  ref="filtreListeCampagne"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"/>
      </div>
    </template>
  </liste-template>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import listeTemplate from '@/components/general/template/listeTemplate';
import breadcrumb from '@/components/general/breadcrumb';
import { CAMPAGNE } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import filtreListeCampagne from '@/components/campagne/filtreListeCampagne';
import inProgress from '@/services/general/inProgress';
import popUpPrevention from '@/components/general/popUpPrevention';
import { archiver, updateVisibiliteAll, deleteAsync } from '@/api/campagne/index';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LISTE_CAMPAGNE } from '@/configuration/general/referenceTableConf';
import BtnActionIcon from '@/components/general/btnActionIcon';
import selecteurAction from '@/components/general/selecteurAction';
import {
  ACTION_MASS_ARCHIVER, ACTION_MASS_DESARCHIVER,
} from '@/configuration/general/actionsConf';
import messageSucces from '@/services/general/messageSucces';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import formatDate from '@/services/general/formatDate';
import imageView from '@/components/general/imageView';
import tagList from '@/components/general/tagList';
import formatIsoDate from '@/services/general/formatIsoDate';
import {
  ACTION_MASS_VISIBLE,
  ACTION_MASS_NON_VISIBLE,
} from '@/configuration/campagne/campagneConf';
import { errorViolatesForeignKeyManager } from '@/services/validation/validation';

const Permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');
const Campagne = createNamespacedHelpers('campagne');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      permCampagne: CAMPAGNE,
      constantes: {
        REFERENCE_TABLE_LISTE_CAMPAGNE,
      },
      unsubscribeValue: null,
      showFiltre: false,
      isPopUpArchiver: false,
      isPopUpDelete: false,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      actions: [
        { action: ACTION_MASS_ARCHIVER, translation: 'general.button.archiver' },
        { action: ACTION_MASS_DESARCHIVER, translation: 'general.button.desarchiver' },
        { action: ACTION_MASS_VISIBLE, translation: 'listeCampagnes.actions.visible' },
        { action: ACTION_MASS_NON_VISIBLE, translation: 'listeCampagnes.actions.nonVisible' },
      ],
      campagneToArchive: {
        archive: false,
        libelle: null,
        libelleSuccess: null,
        ids: [],
      },
      withoutImage: false,
      popupMassVisible: false,
      popupMassNonVisible: false,
      campagneToDelete: null,
      messagesErreurPopUp: [],
      errorPopUp: false,
    };
  },
  components: {
    tagList,
    listeTemplate,
    breadcrumb,
    TableItemsInView,
    BtnActionIcon,
    filtreListeCampagne,
    popUpPrevention,
    parametrageTable,
    selecteurAction,
    imageView,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...Campagne.mapGetters({
      campagnes: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeCampagnes.title'), route: '', isActive: true },
      ];
    },
    nombreCritere() {
      const critereBan = ['actif', 'newsLetter'];
      let nbCritere = calculNombreCritere(this.critereRecherche, critereBan);
      nbCritere += this.critereRecherche.actif !== null ? 1 : 0;
      nbCritere += this.critereRecherche.newsLetter !== null ? 1 : 0;
      if (!this.critereRecherche.datesDebut.dateDebut
        && !this.critereRecherche.datesDebut.dateFin) {
        nbCritere -= 1;
      }
      if (!this.critereRecherche.datesFin.dateDebut
        && !this.critereRecherche.datesFin.dateFin) {
        nbCritere -= 1;
      }
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeCampagnes.tab.libelle'),
          dateDebut: this.$t('listeCampagnes.tab.dateDebut'),
          dateFin: this.$t('listeCampagnes.tab.dateFin'),
          libelleInterne: this.$t('listeCampagnes.tab.libelleInterne'),
          marque: this.$t('listeCampagnes.tab.marque'),
          tags: this.$t('listeCampagnes.tab.tags'),
          creatorUser: this.$t('listeCampagnes.tab.creatorUser'),
          visibleParLaMarque: this.$t('listeCampagnes.tab.visibleParLaMarque'),
          edit: '',
          archiver: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          data.query = cloneDeep(this.critereRecherche);
          data.query.marqueIds = tagInputToArray(this.critereRecherche.marqueIds, 'id');
          data.query.tagIds = tagInputToArray(this.critereRecherche.tagIds, 'id');
          data.query.societeId = this.societeActiveId;
          if (data.query.datesDebut) {
            data.query.datesDebut.dateDebut = formatIsoDate(
              data.query.datesDebut.dateDebut,
            );
            data.query.datesDebut.dateFin = formatIsoDate(
              data.query.datesDebut.dateFin,
            );
          }
          if (data.query.datesFin) {
            data.query.datesFin.dateDebut = formatIsoDate(
              data.query.datesFin.dateDebut,
            );
            data.query.datesFin.dateFin = formatIsoDate(
              data.query.datesFin.dateFin,
            );
          }
          return this.actionLoadCampagne(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.campagnes,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
          image: 'width-50-percent',
        },
        sortable: ['libelle', 'libelleInterne', 'marque', 'dateDebut', 'dateFin'],
      };
    },
    columns() {
      const allColumns = ['selected', 'libelle', 'dateDebut', 'dateFin', 'libelleInterne', 'marque', 'tags', 'creatorUser', 'visibleParLaMarque', 'edit', 'archiver', 'delete'];
      if (!this.withoutImage) {
        allColumns.splice(1, 0, 'image');
      }
      return allColumns;
    },
    allCampagnesSelected() {
      return this.getAllCampagnesSelected().length === this.campagnes.length;
    },
    iconSelectTotal() {
      if (this.allCampagnesSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Campagne.mapActions({
      actionLoadCampagne: 'loadCampagne',
    }),
    finLoading() {
      this.loadingComponent.close();
    },
    getListeTags(tags) {
      if (!tags.length) return [];
      return tags.map(t => t.tag);
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.constantes.REFERENCE_TABLE_LISTE_CAMPAGNE].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    goFirstPage() {
      this.$refs[this.constantes.REFERENCE_TABLE_LISTE_CAMPAGNE].setPage(1);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeCampagne.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.$refs.filtreListeCampagne.initializeFiltre();
      this.$refs.filtreListeCampagne.viderCritere();
      this.$refs.filtreListeCampagne.appliquerCritere();
      this.showFiltre = false;
    },
    getAllCampagnesSelected() {
      return this.campagnes.filter((el) => { return el.selected; });
    },
    selectAll() {
      const select = !this.allCampagnesSelected;
      this.campagnes.forEach((el) => { el.selected = select; });
    },
    manageActions(action) {
      switch (action) {
        case ACTION_MASS_ARCHIVER:
          if (this.checkPermissions(this.permCampagne.supprimer)) {
            this.openPopUpArchivageMulti(true);
          } else this.showPopUp();
          break;
        case ACTION_MASS_DESARCHIVER:
          if (this.checkPermissions(this.permCampagne.supprimer)) {
            this.openPopUpArchivageMulti(false);
          } else this.showPopUp();
          break;
        case ACTION_MASS_VISIBLE:
          if (this.checkPermissions(this.permCampagne.maj)) {
            this.popupMassVisible = true;
          } else this.showPopUp();
          break;
        case ACTION_MASS_NON_VISIBLE:
          if (this.checkPermissions(this.permCampagne.maj)) {
            this.popupMassNonVisible = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$t('general.noActionSelect'));
          break;
      }
    },
    openPopUpArchivage(campagne) {
      this.campagneToArchive = {
        archive: campagne.actif,
        libelle: campagne.actif ? 'listeCampagnes.archiverDesarchiver.archive' : 'listeCampagnes.archiverDesarchiver.desarchive',
        libelleSuccess: campagne.actif ? 'listeCampagnes.archiverDesarchiver.archiveSuccess' : 'listeCampagnes.archiverDesarchiver.desarchiveSuccess',
        ids: [campagne.id],
      };
      this.isPopUpArchiver = true;
    },
    openPopUpArchivageMulti(archive) {
      const ids = this.campagnes.filter((el) => {
        return el.selected;
      }).map(el => el.id);
      this.campagneToArchive = {
        archive: archive,
        libelle: archive ? 'listeCampagnes.archiverDesarchiver.desarchiveMultiple' : 'listeCampagnes.archiverDesarchiver.archiveMultiple',
        libelleSuccess: archive ? 'listeCampagnes.archiverDesarchiver.desarchiveMultipleSuccess' : 'listeCampagnes.archiverDesarchiver.archiveMultipleSuccess',
        ids: ids,
      };
      this.isPopUpArchiver = true;
    },
    async archiverCampagne() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver({
          ids: this.campagneToArchive.ids,
          archiver: this.campagneToArchive.archive,
        });
        this.isPopUpArchiver = false;
        messageSucces(this.$t(this.campagneToArchive.libelleSuccess));
        this.campagneToArchive = {
          archive: false,
          libelle: null,
          libelleSuccess: null,
          ids: [],
        };
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getUser(userId) {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => {
          return user.id === userId;
        });
      return userFind ? userFind.decorator.nomPrenom : this.$i18n.t('general.inconnu');
    },
    getDate(date) {
      return formatDate(date);
    },
    async updateCampagneVisible(visibilite) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateVisibiliteAll({
          ids: this.getAllCampagnesSelected().map(campagne => campagne.id),
          visibleParLaMarque: visibilite,
        });
        this.popupMassVisible = false;
        this.popupMassNonVisible = false;
        messageSucces(this.$t('listeCampagnes.messages.successCampagneUpdateVisibilite'));
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    openPopUpDelete(campagne) {
      this.campagneToDelete = campagne;
      this.isPopUpDelete = true;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    async deleteCampagne() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await deleteAsync(this.campagneToDelete.id);
        this.isPopUpDelete = false;
        messageSucces(this.$t('listeCampagnes.delete.success'));
        this.campagneToDelete = null;
        this.recherche();
      } catch (e) {
        if (e.response.data.error) {
          e.response.data.error.validationErrors.forEach(error => {
            errorViolatesForeignKeyManager(error.message, this.messagesErreurPopUp);
          });

          this.errorPopUp = true;
        } else {
          messageErreur(this.$i18n);
        }
      } finally {
        loadingComponent.close();
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      await this.loadParametreUtilisateur();
      this.setInformationPage(this.$t('pageGescom.campagne.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style>

</style>
